export interface Tag {
  id: string;
  name: string;
  category: string;
  value: string;
}

export interface ITagCategory {
  name: string;
  value: string;
  color: string;
  sortOrder: number;
}

export class TagCategory {
  static TOPIC = {
    name: "Topic",
    value: "Topic",
    color: "#01BCD4",
    sortOrder: 3,
  };
  static LANGUAGE_SKILLS = {
    name: "Language Skill",
    value: "Language Skill",
    color: "#bf01d4",
    sortOrder: 4,
  };
  static BUSINESS_INTERACTIONS = {
    name: "Business Interactions",
    value: "Business Interactions",
    color: "#2cad28",
    sortOrder: 5,
  };
  static SKILL = {
    name: "Skill",
    value: "Skill",
    color: "#FFC700",
    sortOrder: 2,
  };
  // We have this category to easier render Level as tag when it's not a tag actually.
  // We don't let admins to save tags with this category. That's why you can't find it in
  // getAllNames().
  static LEVEL = {
    name: "Level",
    value: "level",
    color: "#67dfff",
    sortOrder: 1,
  };

  static getAllCategories = () => {
    return [
      TagCategory.TOPIC,
      TagCategory.SKILL,
      TagCategory.LEVEL,
      TagCategory.LANGUAGE_SKILLS,
      TagCategory.BUSINESS_INTERACTIONS,
    ];
  };

  static getAllNames = () => {
    return [
      TagCategory.TOPIC.name,
      TagCategory.SKILL.name,
      TagCategory.LEVEL.name,
      TagCategory.LANGUAGE_SKILLS.name,
      TagCategory.BUSINESS_INTERACTIONS.name,
    ];
  };

  static getAllValues = () => {
    return [
      TagCategory.TOPIC.value,
      TagCategory.SKILL.value,
      TagCategory.LEVEL.value,
      TagCategory.LANGUAGE_SKILLS.value,
      TagCategory.BUSINESS_INTERACTIONS.value,
    ];
  };

  static getTagCategoryByName = (categoryName: string) => {
    switch (categoryName) {
      case TagCategory.TOPIC.name:
        return TagCategory.TOPIC;
      case TagCategory.SKILL.name:
        return TagCategory.SKILL;
      case TagCategory.LEVEL.name:
        return TagCategory.LEVEL;
      case TagCategory.LANGUAGE_SKILLS.name:
        return TagCategory.LANGUAGE_SKILLS;
      case TagCategory.BUSINESS_INTERACTIONS.name:
        return TagCategory.BUSINESS_INTERACTIONS;
      default:
        return null;
    }
  };

  static getTagCategoryByValue = (categoryValue: string) => {
    switch (categoryValue) {
      case TagCategory.TOPIC.value:
        return TagCategory.TOPIC;
      case TagCategory.SKILL.value:
        return TagCategory.SKILL;
      case TagCategory.LEVEL.value:
        return TagCategory.LEVEL;
      case TagCategory.LANGUAGE_SKILLS.name:
        return TagCategory.LANGUAGE_SKILLS;
      case TagCategory.BUSINESS_INTERACTIONS.name:
        return TagCategory.BUSINESS_INTERACTIONS;
      default:
        return null;
    }
  };
}

// eslint-disable-next-line no-shadow
export enum TagCategoryValue {
  TOPIC = "Topic",
  LANGUAGE_SKILLS = "Language Skill",
  BUSINESS_INTERACTIONS = "Business Interactions",
  SKILL = "Skill",
  LEVEL = "level",
}

export const TAG_OBJ = {
  name: {
    label: "Name",
    required: true,
    maxLength: 64,
  },
  category: {
    label: "Category",
    required: false,
    maxLength: 64,
    options: TagCategory.getAllNames(),
  },
  description: {
    label: "Description",
    required: true,
    maxLength: 512,
  },
};

export function sortTags(tag1: Tag, tag2: Tag) {
  /**
   * This function is used in sorting the tags. It compares different tags: first it compares by category,
   * and if the categories are equal, then it compares by name (in alphabetical order).
   */
  if (tag1.category && tag2.category && tag1.category !== tag2.category) {
    const category1 = TagCategory.getTagCategoryByName(tag1.category);
    const category2 = TagCategory.getTagCategoryByName(tag2.category);
    return (category1 ? category1.sortOrder : 0) - (category2 ? category2.sortOrder : 0);
  } else {
    if (tag1.name === tag2.name) {
      return 0;
    } else {
      return tag1.name < tag2.name ? -1 : 1;
    }
  }
}
